import styled from "styled-components";
import { Modal, Button } from "antd";

type AsideTalhoesProps = {
  isCollapsedMap: boolean;
};

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CustomModal = styled(Modal)`
    position: relative;
    height: 90%;
  .ant-modal-content {
    border-radius: 10px;

    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;

    flex: 0 0 auto;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;
    
    flex: 1 1 auto;
    display: flex;
    min-height: 0;
  }

  .ant-modal-footer {
    flex: 0 0 auto;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  overflow: hidden;
  display: flex;
  flex: 1 1 auto;
`;

export const AsideTalhoes = styled.div<AsideTalhoesProps>`
  width: 380px;
  background: rgb(250, 250, 250);
  border-left: 1px solid rgb(224, 224, 224);
  display: ${({ isCollapsedMap }) => (isCollapsedMap ? "none" : "flex")};
  flex-direction: column;
  transition: width 0.3s;
  box-shadow: rgba(0, 0, 0, 0.05) -2px 0px 8px;
`;

export const AsideTalhoesWrap = styled.div`
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 20px;
  border-bottom: 2px solid #e8eaf6;
`;

export const HeaderAsideTalhoes = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const HeaderAsideTalhoesWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderAsideTalhoesWrapContentIcon = styled.div`
  width: 32px;
  height: 32px;
  background: #009157;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(63, 81, 181, 0.3);

  svg {
    color: #fff;
  }
`;

export const HeaderAsideTalhoesWrapContentTitle = styled.div`
  h3 {
    font-size: 16px;
    font-weight: 600;
    color: #009157;
    line-height: 1.2;
  }

  p {
    font-size: 12px;
    color: #5f6368;
    font-weight: 400;
  }
`;

export const ButtonChevronRight = styled.button`
  background: none;
  border: none;
  color: rgb(95, 99, 104);
  font-size: 20px;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: 0.2s;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: rgb(63, 81, 181);
    background-color: rgba(63, 81, 181, 0.1);
  }
`;

export const ContentFieldSearch = styled.div`
  position: relative;
  margin-bottom: 4px;

  input {
    width: 100%;
    padding: 9px 16px 9px 44px;
    border: 2px solid rgb(232, 234, 246);
    border-radius: 12px;
    font-size: 14px;
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    transition: 0.2s;
    font-weight: 400;
    color: rgb(51, 51, 51);
    box-shadow: none;
  }

  svg {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #9e9e9e;
    font-size: 20px;
    transition: color 0.2s;
  }
`;

export const ContainerCheckboxAll = styled.div`
  margin-top: 16px;
  padding: 10px 16px;
  background: rgb(232, 244, 253);
  border: 1px solid rgb(187, 222, 251);
  border-radius: 12px;
  transition: 0.2s;
`;

export const ContainerCheckboxAllLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    color: #2196f3;
    font-size: 20px;
    opacity: 0.7;
  }
`;

export const ContainerCheckboxAllInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  input {
    width: 18px;
    height: 18px;
    accent-color: #2196f3;
    margin: 0;
    cursor: pointer;
  }
`;

export const ContainerCheckboxAllText = styled.div`
  flex: 1;

  strong {
    font-size: 14px;
    color: #1565c0;
    font-weight: 600;
    line-height: 1.3;
    display: block;
  }
`;

export const SectionContent = styled.div`
  flex: 1;
  padding: 16px 12px;
  background: #fafafa;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 16px;
`;

export const ButtonStyled = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #11a557;
  border: none;

  &:hover, &:active {
    background-color: #0e8a47;
  }
`